<template>
    <table class="table table-striped table-condensed table-bordered brTable">
        <thead>
            <tr>
                <th v-for="h in cHeaders">
                    {{h}}
                </th>
            </tr>
        </thead>
        <tbody>
        <tr v-for="row in items">
            <td v-for="h in cHeaders">
                <a v-if="h.match(/link/i)" :href="row[h]" target="_blank">{{row[h]}}</a>
                <span v-else>{{ row[h] }}</span>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        name: 'br-simple-table',
        props: { 'items': {required:true}, 'headers': {required:false}},
        computed: {
            cHeaders: {
                get: function() {
                    if( this.headers ) { return this.headers; }
                    return _.keys(_.first(this.items));
                }
            }
        },
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
    table.table thead td {
        font-weight: bold;
    }
    table.table tbody td, table.table tbody tr, table.table thead tr {
        text-align: center;
        height: 24px;
        padding-bottom: 0px;
        margin-bottom: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/BRSimpleTable.vue